import { attemptParseJSON } from 'src/utils'
import dayjs from 'src/utils/dayjs'

const PROMPT_HELPER_ENABLED_HINT_LAST_SHOWN_STORAGE_KEY =
  'generator::prompt-helper-enabled-hint-shown'

export function hasPromptHelperEnabledHintShownToday() {
  const val = localStorage.getItem(
    PROMPT_HELPER_ENABLED_HINT_LAST_SHOWN_STORAGE_KEY,
  )
  const lastShownDate = attemptParseJSON(val)
  const hasShownToday =
    lastShownDate && dayjs(lastShownDate).isAfter(dayjs().startOf('day'))

  return hasShownToday
}

export function resetPromptHelperLastShownTime() {
  localStorage.setItem(
    PROMPT_HELPER_ENABLED_HINT_LAST_SHOWN_STORAGE_KEY,
    JSON.stringify(new Date().getTime()),
  )
}
